export default {
    // domain: 'http://zbjd.net',
    // domain: 'http://zbjdxm.jctmj.cn',
    domain: '',
}